import { combineEpics } from 'redux-observable';
import fetchLocationsData from './fetch-locations-data/index.tsx';
import setNewLocation from './set-new-location/index.tsx';

export default combineEpics(fetchLocationsData, setNewLocation);
